export default "__VITE_ASSET__BGQJ$soj__"